import MenuBar from '../../USA/Component/MenuBar';
import Footer from '../../USA/Component/Footer';

export default function MembershipReports() {
  return (
    <>
      <MenuBar />

      <section className="page-banner">
        <div className="image-layer"></div>

        <div className="auto-container">
          <h1>Membership Reports</h1>
        </div>

        <div className="breadcrumb-box">
          <div className="auto-container">
            <ul className="bread-crumb clearfix">
              <li>
                <a href="/USA/Home">Home</a>
              </li>
              <li className="active">Membership Reports</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="contact-section contact-page" style={{ marginTop: '20px' }}>
        <div className="auto-container">
          <div className="sec-title centered">
            <div className="upper-icon"></div>
            <h2>Reports</h2>
          </div>

          <div className="alert alert-info" role="alert">
            Report endpoints are not yet configured in Swagger. Once you share the report API paths and
            request parameters, I will wire the filters and tables here.
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
